/**
 * App-level constants. Keep this file tiny.
 */

export const appConfig = {
  name: 'Workerize',
  themeStorageKey: 'workerize.theme',
  localeStorageKey: 'workerize.locale',
  defaultLocale: 'en' as const,
  supportedLocales: ['en', 'ar'] as const,
} as const;

export type SupportedLocale = (typeof appConfig.supportedLocales)[number];
